(function () {
    $ (function () {
        $ (document).on ("click", ".i-toggle", function (e) {
            e.preventDefault ();
            const $_this = $ (this);
            const checked = $_this.is ("._checked");
            $_this.trigger ("is:change", [checked]).toggleClass ("_checked");
        });
    })
} ());
